export default "__VITE_ASSET__4753aa4c__"